module.exports = __webpack_public_path__ + "media/images/logo_syla-ff2bc5959d130eb4ebcd7a496e656812.png";